/**
 * Fallback copy for the homepage, mirroring the backend seed for
 * `homepage.*` site settings. Used only until the public settings load (and if
 * a key is missing), so the page renders identically with or without network.
 */
export const HOMEPAGE_DEFAULTS = {
  hero: {
    show: true,
    headline: "Whatever you're studying with, know where you stand for the **ADC Written Examination**.",
    subheadline: "PassADC sits on top of your existing books, videos and notes. Take a free three-minute readiness check and get a personalised plan showing exactly what to focus on next.",
    button_label: "Take the free readiness check",
    button_url: "/readiness-check",
    subline: "About 3 minutes \u00b7 No credit card \u00b7 See your score and next steps immediately",
  },
  sits_on_top: {
    show: true,
    badge: "Sits on top of your existing prep",
    heading: "Keep your books, videos and notes. Add the layer that tells you if you're ready.",
    body: "PassADC is a practice and readiness system, not a replacement for your primary study. Every question is scenario-based, weighted to the ADC Part 1 blueprint, and reviewed for clinical accuracy. Explanations reference current Australian guidelines so what you learn holds up on exam day.",
    bullets: [
      "Complements Mosby's, First Aid, video courses and mentors",
      "Weighted by subject area to the ADC blueprint",
      "Explanations aligned to Australian guidelines",
      "A live Readiness Score no textbook can give you",
    ],
    disclaimer: "PassADC is an independent preparation platform. We are not affiliated with, endorsed by, or connected to the Australian Dental Council. \"ADC\" is used to identify the exam we prepare candidates for.",
  },
  comparison: {
    show: true,
    heading: "Why students switch to us from **expensive cohort coaching**",
    subheading: "We respect your time. And your wallet.",
    col_us: "Our app",
    col_them: "Cohort coaching ($1,050+)",
    rows: [
      { label: "MCQ practice volume", us: "1,200+ questions, unlimited practice", them: "~600-800 recycled Qs, limited access" },
      { label: "Full mock exams", us: "3 ADC-style readiness trials - 140 Qs, timed", them: "Extra cost or not included" },
      { label: "Personalisation", us: "Adaptive - focuses on YOUR weak areas", them: "Same plan for everyone" },
      { label: "Doubt-clearing", us: "Smart tutor 24/7 on every question", them: "Scheduled Zoom + WhatsApp queue" },
      { label: "Pass prediction", us: "Live readiness score on every login", them: "\"Highest pass rate\" (no proof)" },
      { label: "Start studying", us: "30 seconds - anytime", them: "Wait for April or October cohort" },
      { label: "Part 2 (OSCE) prep", us: "33 cases + voice role-play included", them: "Separate paid course (extra $$)" },
      { label: "Community", us: "Built-in member community", them: "WhatsApp group chaos" },
      { label: "Price", us: "From $19/month - cancel anytime", them: "\u2248 $1,050 USD upfront" },
    ],
  },
  pricing: {
    show: true,
    heading: "Simple pricing. **A supplement, not a course fee.**",
    subheading: "Start free. Upgrade when you want personalisation, the full readiness system and the 80% Readiness Commitment. Prices in AUD.",
    guarantee_line: "Try Pro free for 7 days \u00b7 cancel anytime from your account",
  },
  commitment: {
    show: true,
    heading: "The **Pass Readiness** commitment",
    body: "If you hit **80%+ exam readiness** in our app and still fail the ADC Part 1, we'll give you **free Pro access until your next attempt**. No questions, no forms, no gotchas.",
    steps: [
      { t: "Hit 80%+ readiness", d: "Tracked in real-time in your dashboard" },
      { t: "Sit your ADC exam", d: "Any official exam sitting" },
      { t: "Didn't pass? Free Pro", d: "Until your next attempt" },
    ],
    footnote: "We're serious about your success. Just email support with your candidate number + result.",
  },
  final_cta: {
    show: true,
    heading: "Stop guessing what to study.\n**Find out where you stand.**",
    body: "Take the free 3-minute readiness check - 6 ADC-style questions. Get your snapshot instantly, then unlock the full study breakdown with a free account.",
    button_label: "Check My ADC Readiness Free",
    button_url: "/readiness-check",
    subline: "Takes about 3 minutes \u00b7 No credit card required",
  },
};
